import React from 'react';
import { MdClose } from 'react-icons/md';

import styles from './Modale.module.scss';
import reactDom from 'react-dom';

export default function Modale({ isOpen, modaleToggle, className, hideClose, children }) {
  if (!isOpen) return null;
  return reactDom.createPortal(
    <div className={`${styles['modale-container']} ${isOpen ? styles['is-active'] : ""}`} >
      <div className={`${styles['modale']} ${className ? className : ''} ${isOpen ? styles['is-active'] : ""}`}>
        {!hideClose && <button
          type="button"
          onClick={() => modaleToggle(false)}
          className={styles['close']}>
          <MdClose size={20} color={'#656565'} />
        </button>
        }
        {children}
      </div>
    </div>
    , document.getElementById('portal'));
}